module.exports = __webpack_public_path__ + "static/media/mobile_frame.4680144b.png";